import { ObfOptions } from '../interfaces/obf-options.interface';
import { ObfClientSettings } from '../interfaces/obf-client-settings.interface';
import { obfOptionsFilterStructure } from '../constants/obf-options-filter-structure';
import { queryParamsToLookFor } from '../constants/query-params-to-look-for';
import { getUrlVars } from '../helpers/helpers';
import { Dependencies } from '../interfaces/dependencies-types';

import DependenciesInjector from '../helpers/dependencies-injector';

import { ClientCookieService } from './client-cookie-service';

// import { ObfClientSettings } from './clientSdk/interfaces/obf-client-settings.type';

export class OptionsService implements Dependencies {

    private obfClientSettings: ObfClientSettings | any;
    
    private clientCookieService: ClientCookieService;

    constructor() { }

    async initialize() {
        this.clientCookieService = await DependenciesInjector.getRegistered('ClientCookieService');
    }

    // Set OBF Client Settings
    public setObfClientSettings(obfOptions: ObfOptions): void {
        this.obfClientSettings = {};

        this.obfClientSettings.app_url = obfOptions.app_url;
        this.obfClientSettings.api_url = obfOptions.api_url;
        this.obfClientSettings.accounts_url = obfOptions.accounts_url;
        this.obfClientSettings.key = obfOptions.key;
        this.obfClientSettings.profile_id = obfOptions.profile_id;
        this.obfClientSettings.profile = obfOptions.profile;
        this.obfClientSettings.main_url = window.obfOptions.main_url = window.obfOptions?.main_url ? window.obfOptions.main_url : window.location.origin + "/";
        this.obfClientSettings.domain_url = obfOptions.domain_url;
        this.obfClientSettings.phone = obfOptions.phone;
        this.obfClientSettings.website_name = obfOptions.website_name;
        this.obfClientSettings.init_event = obfOptions.init_event ? obfOptions.init_event : 'on_load';
        this.obfClientSettings.search = obfOptions.search ? obfOptions.search : false;
        
    };

    // Get OBF Client Settings
    public getObfClientSettings(): ObfClientSettings {

        if (!this.obfClientSettings) {
            const obfOptions = this.getObfOptions();
            this.setObfClientSettings(obfOptions);
        }

        return this.obfClientSettings;
    }

    /**
     * Check for required obf options 
     * @param ObfOptions 
     */
    public validateObfOptions() {

        const obfOptions: ObfOptions = this.getObfOptions();
        let result = true;

        if (!obfOptions) {
            return false;
        }

        if (obfOptions.api_url === undefined) {
            // console.warn('WARNING! Please setup obfOptions.api_url');
            // result = false;
        }

        if (obfOptions.app_url === undefined) {
            // console.error('ERROR! Please setup obfOptions.app_url');
            result = false;
        }

        if (obfOptions.key === undefined) {
            // console.error('ERROR! Please setup obfOptions.key');
            result = false;
        }

        if (obfOptions.profile_id === undefined) {
            // console.error('ERROR! Please setup obfOptions.profile_id');
            result = false;
        }

        if (obfOptions.country === undefined) {
            // console.error('ERROR! Please setup obfOptions.country');
            result = false;
        }

        return result;
    }

    /**
     * Validate if ObfOptions have the min request settings 
     * @param ObfOptions 
     */
    public checkForObfOptions() {
        let result = true;

        if (typeof window.obfOptions == 'undefined') {
            console.error('Please set obfOptions before loading client.js . [var obfOptions = {\'...\'};]');
            result = false;
        }

        return result;
    }

    public getObfOptions(showWarnings = false) {
        let filteredObfOptions: ObfOptions = {};
        obfOptionsFilterStructure.map(objectProperty => {
            for (let index = 0; index < objectProperty.allProperty.length; index++) {

                const element = objectProperty.allProperty[index];
                if (window.obfOptions.hasOwnProperty(element.selector)) {

                    if (objectProperty.type && (typeof window.obfOptions[element.selector] !== objectProperty.type && objectProperty.type == 'number' && typeof (Number(window.obfOptions[element.selector])) !== objectProperty.type)) {
                        console.warn('WARNING! Property "' + element.selector + '" has wrong type of value(' + window.obfOptions[element.selector] + ') please check the configuration expect: ' + objectProperty.type + ' got: ' + typeof window.obfOptions[element.selector] + ' !!!')
                        delete window.obfOptions[element.selector];
                        return;
                    }

                    if (objectProperty.valueChange && objectProperty.valueChange.length) {
                        const valueChanger = objectProperty.valueChange.find((el) => {
                            return el.old == window.obfOptions[element.selector];
                        });

                        if (valueChanger) {
                            filteredObfOptions[objectProperty.property] = valueChanger.new;
                        }
                    } else if (objectProperty.childrenPropertys) {
                        if (!filteredObfOptions[objectProperty.property]) {
                            filteredObfOptions[objectProperty.property] = {};
                        }
                        if (window.obfOptions[objectProperty.property]) {
                            objectProperty.childrenPropertys.map(el => {
                                const objectInstance = window.obfOptions[objectProperty.property];
                                Object.keys(window.obfOptions[objectProperty.property]).map(key => {
                                    el.allProperty.map(props => {
                                        if (props.selector == key) {
                                            const obj: any = {};
                                            obj[el.property] = objectInstance[key];
                                            Object.assign(filteredObfOptions[objectProperty.property], obj)
                                        }

                                        return props;
                                    });
                                })
                            })
                        }

                    } else {
                        if (element.selector === 'showPhone') {
                            filteredObfOptions[objectProperty.property] = window.obfOptions[element.selector] === false ? true : false;
                        } else {
                            filteredObfOptions[objectProperty.property] = window.obfOptions[element.selector];
                        }
                    }

                    if (element.dep && showWarnings) {
                        // DISABLE WARNINGS FOR NOW
                        console.warn('WARNING! Property "' + element.selector + '" has been deprecated, please use the new "' + objectProperty.property + '" property instead!');
                    }
                }
            }
        });

        const fullDomainUrl = window.location.href;

        filteredObfOptions.full_domain_url = fullDomainUrl;
        
        return filteredObfOptions;
    }

    //TODO change it to return object with key/value and build the string for iframe src inside iframe controller
    public getObfQueryParams() {

        const currentQueryParams = getUrlVars();

        let queryParamsString = '?cache=' + new Date().getTime();
        let parentCookieParams = this.clientCookieService.getCookie('parent_params');
        let parentParams = [];

        // extract array from cookie parent params
        if (parentCookieParams) {
            if (parentCookieParams.indexOf('?') > -1) parentCookieParams = parentCookieParams.replace('?', '');

            if (parentCookieParams.indexOf('&') > -1) {
                parentParams = parentCookieParams.split('&');
            } else {
                parentParams.push(parentCookieParams);
            }

            // set query params from cookie
            parentParams.forEach((param) => {
                if (param.indexOf('utp') > -1) {
                    let extractedParam = param.split('=');

                    if (extractedParam?.length > 1) {
                        currentQueryParams[extractedParam[0]] = extractedParam[1];
                    }
                }
                if (param.indexOf('utm_') > -1) {
                    let extractedUtmParam = param.split('=');

                    if (extractedUtmParam?.length > 1) {
                        currentQueryParams[extractedUtmParam[0]] = extractedUtmParam[1];
                    }
                }
            });
        }

        // Set campaign_abbr from cookie
        if (this.clientCookieService.getCookie('campaign_abbr')) {
            currentQueryParams['fs_payload[campaign_abbr]'] = this.clientCookieService.getCookie('campaign_abbr');
        }
        // Set campaign_id from cookie
        if (this.clientCookieService.getCookie('campaign_id')) {
            currentQueryParams['fs_payload[campaign_id]'] = this.clientCookieService.getCookie('campaign_id');
        }
        // Set campaign_phone from cookie
        if (this.clientCookieService.getCookie('campaign_phone')) {
            currentQueryParams['fs_payload[campaign_phone]'] = this.clientCookieService.getCookie('campaign_phone');
        }

        queryParamsToLookFor.map((queryParam: any) => {
            let queryStringBuilder = '';

            if (queryParam.qProperty.indexOf('*') !== -1) {
                let a = Object.keys(currentQueryParams);
                let findResults = 0;

                a.map((el: string) => {
                    if (el.includes(queryParam.qProperty.split('[*]')[0])) {

                        queryStringBuilder += findResults ? '&' + el + '=' + currentQueryParams[el] : el + '=' + currentQueryParams[el];
                        findResults++;
                    }
                });
            } else {
                for (let index = 0; index < queryParam.allSelectors.length; index++) {
                    let querySelector = queryParam.allSelectors[index].qSelector;

                    if (currentQueryParams[querySelector]) {
                        queryStringBuilder = queryParam.qProperty + '=' + currentQueryParams[querySelector];
                        if (queryParam.allSelectors[index].dep) {
                            console.warn(
                                'WARNING! Property "' + querySelector + '" has been deprecated, please use the new "' +
                                queryParam.qProperty
                                + '" property instead!'
                            );
                        }
                    }
                }
            }

            queryParamsString += queryStringBuilder.length > 1 ? '&' + queryStringBuilder : queryStringBuilder;

        });

        return queryParamsString.length > 1 ? queryParamsString : '';
    }

    public resetObfOptions() {
        obfOptionsFilterStructure.map(objectProperty => {
            if (objectProperty.reset) {
                for (let index = 0; index < objectProperty.allProperty.length; index++) {
                    const element = objectProperty.allProperty[index];

                    // RESET Property
                    if (window.obfOptions[element.selector] && element.selector !== 'fs_payload') {
                        delete window.obfOptions[element.selector];
                    }

                    // FS_PAYLOAD property reset
                    if (element.selector == 'fs_payload' && window.obfOptions['fs_payload']) {
                        obfOptionsFilterStructure.map(objectPropertyChild => {
                            if (objectPropertyChild.reset) {
                                for (let j = 0; j < objectPropertyChild.allProperty.length; j++) {
                                    const childElement = objectPropertyChild.allProperty[j];
                                    if (window.obfOptions.fs_payload[childElement.selector]) {
                                        delete window.obfOptions[childElement.selector];
                                    }
                                }
                            }
                        })
                    }
                }
            }
        });
    }

}
